<nav class="navbar--container">
  <div
    [class.container--collapsed]="sidebarCollapsed"
    [class.container--expanded]="!sidebarCollapsed"
  >
    <div id="arrow--container">
      @if (sidebarCollapsed) {
        <app-nav-button
          (click)="buttonClicked()"
          iconName="chevron_right"
          buttonId="expand-btn"
          label="Expand"
        ></app-nav-button>
      }
      @if (!sidebarCollapsed) {
        <app-nav-button
          (click)="buttonClicked()"
          iconName="chevron_left"
          buttonId="collapse-btn"
          label="Collapse"
        ></app-nav-button>
      }
    </div>
    <div id="logo--container">
      @if (sidebarCollapsed) {
        <img
          id="cropped-logo"
          [routerLink]="'dashboard/devices'"
          src="assets/img/ogi-icon-logo.png"
          alt="OGI Logo"
        />
      }
      @if (!sidebarCollapsed) {
        <img
          id="full-logo"
          [routerLink]="'dashboard/devices'"
          src="assets/img/ogi-logo.png"
          alt="OGI Logo"
        />
      }
    </div>
    <div id="menu--container">
      <div id="full-menu">
        <div class="subsection--container">
          @if (!sidebarCollapsed) {
            <app-dropdown-form-field
              id="lab-list"
              [field]="laboratorySelectField"
              [parentForm]="labSelectForm"
              dropdownStyle="nav"
            ></app-dropdown-form-field>
          }
        </div>
        <div id="full-menu-buttons">
          <app-nav-button
            routerLink="dashboard/devices"
            iconName="dashboard"
            buttonId="dashboard-btn"
            label="Dashboard"
            [displayText]="!sidebarCollapsed"
          ></app-nav-button>
          <div
            class="submenu"
            [class.submenu--dismissed]="dismissedSubmenu() === 'experiments'"
            (mouseleave)="clearDismissed()"
            (focusout)="clearDismissed()"
          >
            <app-nav-button
              iconName="science"
              buttonId="experiments-btn"
              label="Experiments"
              [displayText]="!sidebarCollapsed"
            ></app-nav-button>
            <div
              class="submenu-content"
              (click)="dismissSubmenu('experiments')"
            >
              <div class="submenu-buttons">
                <app-nav-button
                  routerLink="experiment/0/set-parameters"
                  iconName="biotech"
                  buttonId="new-experiment-btn"
                  label="New Experiment"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
                <app-nav-button
                  routerLink="experiment/templates"
                  iconName="assignment"
                  buttonId="templates-btn"
                  label="Templates"
                  [displayText]="true"
                  [isDisabled]="checkSuperUserPermissions()"
                ></app-nav-button>
                <app-nav-button
                  routerLink="experiment/templates/new"
                  iconName="assignment_add"
                  buttonId="new-template-btn"
                  label="New Template"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
              </div>
            </div>
          </div>
          <app-nav-button
            routerLink="calibration/create-calibration"
            iconName="timeline"
            buttonId="calibration-btn"
            label="New Calibration"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              checkSuperUserPermissions() ||
              !(currentUser.role | roleCheck: editAccessRoles)
            "
          ></app-nav-button>
          <app-nav-button
            routerLink="device/create-device"
            iconName="stream"
            buttonId="devices-btn"
            label="Add Device"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              checkSuperUserPermissions() ||
              !(currentUser.role | roleCheck: labAdminRoles)
            "
          >
          </app-nav-button>
          <app-nav-button
            routerLink="user/add-user"
            iconName="person_add"
            buttonId="add-user-btn"
            label="Add User"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              !selectedLab ||
              !(currentUser.role | roleCheck: ogiAdminAndSuperUserRoles)
            "
          ></app-nav-button>
          <app-nav-button
            routerLink="laboratories/view-lab"
            iconName="home"
            buttonId="view-lab-btn"
            label="View Lab"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="!selectedLab"
          ></app-nav-button>
          <app-nav-button
            [routerLink]="'organisations/' + currentOrganisation + '/details'"
            iconName="location_city"
            buttonId="view-org-btn"
            label="View Organisation"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="!(currentUser.role | roleCheck: superAdminRoles)"
          ></app-nav-button>
        </div>
      </div>
      <div id="reduced-menu">
        <app-nav-button
          routerLink="dashboard/devices"
          iconName="dashboard"
          buttonId="dashboard-btn"
          label="Dashboard"
          [displayText]="!sidebarCollapsed"
        ></app-nav-button>
        <div id="full-menu">
          <app-nav-button
            routerLink="experiment/0/set-parameters"
            iconName="science"
            buttonId="experiment-btn"
            label="New Experiment"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              checkSuperUserPermissions() ||
              !(currentUser.role | roleCheck: editAccessRoles)
            "
          ></app-nav-button>
          <app-nav-button
            routerLink="calibration/create-calibration"
            iconName="timeline"
            buttonId="calibration-btn"
            label="New Calibration"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              checkSuperUserPermissions() ||
              !(currentUser.role | roleCheck: editAccessRoles)
            "
          ></app-nav-button>
          <app-nav-button
            routerLink="device/create-device"
            iconName="stream"
            buttonId="devices-btn"
            label="Add Device"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              checkSuperUserPermissions() ||
              !(currentUser.role | roleCheck: labAdminRoles)
            "
          >
          </app-nav-button>
          <app-nav-button
            routerLink="user/add-user"
            iconName="person_add"
            buttonId="add-user-btn"
            label="Add User"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="
              !selectedLab ||
              !(currentUser.role | roleCheck: ogiAdminAndSuperUserRoles)
            "
          ></app-nav-button>
          <app-nav-button
            routerLink="laboratories/view-lab"
            iconName="home"
            buttonId="view-lab-btn"
            label="View Lab"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="!selectedLab"
          ></app-nav-button>
          <app-nav-button
            [routerLink]="'organisations/' + currentOrganisation + '/details'"
            iconName="location_city"
            buttonId="view-org-btn"
            label="View Organisation"
            [displayText]="!sidebarCollapsed"
            [isDisabled]="!(currentUser.role | roleCheck: superAdminRoles)"
          ></app-nav-button>
        </div>
        <div id="reduced-menu-buttons">
          <div
            class="submenu"
            [class.submenu--dismissed]="
              dismissedSubmenu() === 'experiments-reduced'
            "
            (mouseleave)="clearDismissed()"
            (focusout)="clearDismissed()"
          >
            <app-nav-button
              iconName="science"
              buttonId="experiments-btn"
              label="Experiments"
              [displayText]="!sidebarCollapsed"
            ></app-nav-button>
            <div
              class="submenu-content"
              (click)="dismissSubmenu('experiments-reduced')"
            >
              <div class="submenu-buttons">
                <app-nav-button
                  routerLink="experiment/0/set-parameters"
                  iconName="play_arrow"
                  buttonId="new-experiment-btn"
                  label="New Experiment"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
                <app-nav-button
                  routerLink="experiment/templates"
                  iconName="list"
                  buttonId="templates-btn"
                  label="Templates"
                  [displayText]="true"
                  [isDisabled]="checkSuperUserPermissions()"
                ></app-nav-button>
                <app-nav-button
                  routerLink="experiment/templates/new"
                  iconName="post_add"
                  buttonId="new-template-btn"
                  label="New Template"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
              </div>
            </div>
          </div>
          <div
            class="submenu"
            [class.submenu--dismissed]="dismissedSubmenu() === 'add'"
            (mouseleave)="clearDismissed()"
            (focusout)="clearDismissed()"
          >
            <app-nav-button
              iconName="add"
              buttonId="add-btn"
              label="Add"
              [displayText]="!sidebarCollapsed"
            ></app-nav-button>
            <div class="submenu-content" (click)="dismissSubmenu('add')">
              <div class="submenu-buttons">
                <app-nav-button
                  routerLink="experiment/0/set-parameters"
                  iconName="science"
                  buttonId="experiment-btn"
                  label="New Experiment"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
                <app-nav-button
                  routerLink="calibration/create-calibration"
                  iconName="timeline"
                  buttonId="calibration-btn"
                  label="New Calibration"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: editAccessRoles)
                  "
                ></app-nav-button>
                <app-nav-button
                  routerLink="device/create-device"
                  iconName="stream"
                  buttonId="devices-btn"
                  label="Add Device"
                  [displayText]="true"
                  [isDisabled]="
                    checkSuperUserPermissions() ||
                    !(currentUser.role | roleCheck: labAdminRoles)
                  "
                >
                </app-nav-button>
                <app-nav-button
                  routerLink="user/add-user"
                  iconName="person_add"
                  buttonId="add-user-btn"
                  label="Add User"
                  [displayText]="true"
                  [isDisabled]="
                    !selectedLab ||
                    !(currentUser.role | roleCheck: ogiAdminAndSuperUserRoles)
                  "
                ></app-nav-button>
              </div>
            </div>
          </div>
          <div
            class="submenu"
            [class.submenu--dismissed]="dismissedSubmenu() === 'view'"
            (mouseleave)="clearDismissed()"
            (focusout)="clearDismissed()"
          >
            <app-nav-button
              iconName="location_city"
              buttonId="view-btn"
              label="View"
              [displayText]="!sidebarCollapsed"
            ></app-nav-button>
            <div class="submenu-content" (click)="dismissSubmenu('view')">
              <div class="submenu-buttons">
                <app-nav-button
                  routerLink="laboratories/view-lab"
                  iconName="home"
                  buttonId="view-lab-btn"
                  label="View Lab"
                  [displayText]="true"
                  [isDisabled]="!selectedLab"
                ></app-nav-button>
                <app-nav-button
                  [routerLink]="
                    'organisations/' + currentOrganisation + '/details'
                  "
                  iconName="location_city"
                  buttonId="view-org-btn"
                  label="View Organisation"
                  [displayText]="true"
                  [isDisabled]="
                    !(currentUser.role | roleCheck: superAdminRoles)
                  "
                ></app-nav-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      @if (currentUser.role === Role.OGI_Super_Administrator) {
        <div id="admin--container">
          <div
            class="submenu"
            [class.submenu--dismissed]="dismissedSubmenu() === 'administration'"
            (mouseleave)="clearDismissed()"
            (focusout)="clearDismissed()"
          >
            <app-nav-button
              iconName="manage_accounts"
              buttonId="administration-btn"
              label="Administration"
              [displayText]="!sidebarCollapsed"
            ></app-nav-button>
            <div
              class="submenu-content"
              (click)="dismissSubmenu('administration')"
            >
              <div class="submenu-buttons">
                <app-nav-button
                  routerLink="approvals/labs"
                  iconName="admin_panel_settings"
                  buttonId="approvals-btn"
                  label="Approvals"
                  [displayText]="true"
                ></app-nav-button>
                <app-nav-button
                  routerLink="organisations/administration"
                  iconName="location_city"
                  buttonId="view-orgs-btn"
                  label="Organisations"
                  [displayText]="true"
                ></app-nav-button>
                <app-nav-button
                  routerLink="administration/users"
                  iconName="people"
                  buttonId="admin-users-btn"
                  label="Users"
                  [displayText]="true"
                ></app-nav-button>
                <app-nav-button
                  routerLink="administration/devices"
                  iconName="stream"
                  buttonId="admin-devices-btn"
                  label="Devices"
                  [displayText]="true"
                ></app-nav-button>
              </div>
            </div>
          </div>
        </div>
      }
      <div id="user--container">
        <div
          class="submenu"
          [class.submenu--dismissed]="dismissedSubmenu() === 'settings'"
          (mouseleave)="clearDismissed()"
          (focusout)="clearDismissed()"
        >
          <app-nav-button
            iconName="settings"
            buttonId="settings-btn"
            label="Settings"
            [displayText]="!sidebarCollapsed"
          ></app-nav-button>
          <div class="submenu-content" (click)="dismissSubmenu('settings')">
            <div class="submenu-buttons">
              <app-nav-button
                routerLink="account/user-profile"
                iconName="account_circle"
                buttonId="user-btn"
                label="Account"
                [displayText]="true"
              ></app-nav-button>
              @if (
                currentUser.role === Role.Super_User ||
                currentUser.role === Role.OGI_Super_Administrator
              ) {
                <app-nav-button
                  routerLink="help"
                  iconName="help"
                  buttonId="help-btn"
                  label="Help"
                  [displayText]="true"
                ></app-nav-button>
              }
              <app-nav-button
                routerLink="about"
                iconName="info"
                buttonId="about-btn"
                label="About"
                [displayText]="true"
              ></app-nav-button>
            </div>
          </div>
        </div>
        <app-nav-button
          (buttonClicked)="onLogout()"
          iconName="logout"
          buttonId="logout-btn"
          label="Logout"
          [displayText]="!sidebarCollapsed"
        ></app-nav-button>
      </div>
    </div>
  </div>
</nav>
